import errors from './errors';
import home from './home';
import login from './login';
import onboarding from './onboarding';
import otpEmail from './otp-email';
import report from './report';
import review from './review';
import settings from './settings';
import templates from './templates';
import termsOfService from './terms-of-service';

const hr = {
  home,
  settings,
  templates,
  login,
  report,
  review,
  termsOfService,
  errors,
  otpEmail,
  onboarding,
};

export default hr;
